import { GET_DETAIL_GROUP_ADDR, GET_LIST_GROUP_ADDR } from "shared/constants/ActionTypes";

const initialState = {
    listGroup: [],
    detailGroup: null,
    sequenceUpdate: null
}

const GroupAddressbookReducer = (state=initialState,action) => {
    switch (action.type) {
        case GET_LIST_GROUP_ADDR:
            return {
                ...state,
                listGroup: action.payload
            }
        case GET_DETAIL_GROUP_ADDR:
            return {
                ...state,
                detailGroup: action.payload
            }
        default:
            return {
                ...state
            }
        }
    };

export default GroupAddressbookReducer